module.exports = __webpack_public_path__ + "img/1476909415.df81800e.jpg";